// @flow
import React, { Component, Fragment } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";

import type { ErrorsType } from "../../types/UserFormType";
import {
  ErrosDisplay,
  setErrorMsg
} from "../../../account/containers/ErrosDisplay";
import { generateBill } from "../../actions/billingAdminActions";
import {
  StyledTextField,
  StyledSelect,
  CancelButton,
  SubmitButton,
  SingleCheckBox
} from "imagus-components";

type GenerateBillFormPropsType = {
  date: string,
  historyBillings: Array<ChartType>,
  total: string,
  billingId: string
};

type GenerateBillFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  forLast: boolean,
  year: number,
  month: number,
  messages: Array<*>
};

class GenerateBillForm extends Component<
  GenerateBillFormPropsType,
  GenerateBillFormStatesType
> {
  constructor(props: GenerateBillFormPropsType) {
    super(props);
    this.state = {
      errors: {},
      loading: false,
      forLast: false,
      year: "",
      month: "",
      messages: []
    };
  }

  handleTextChange = (e: Event): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(
      { [name]: value },
      (): * => {
        if (name === "month") {
          this.checkMonthSelect();
        }
      }
    );
  };

  handleCheckBoxChange = (e: Event): * => {
    const name = e.target.name;
    const value = !this.state[name];
    this.setState({ [name]: value });
  };

  checkMonthSelect = (): * => {
    if (this.state.forLast === false) {
      if (this.state.month === "") {
        this.setState({
          errors: setErrorMsg(
            this.state.errors,
            "system",
            "Please specify Set Month."
          )
        });
      } else {
        this.setState({
          errors: setErrorMsg(this.state.errors, "system", "", true)
        });
      }
    } else {
      this.setState({
        errors: setErrorMsg(this.state.errors, "system", "", true)
      });
    }
  };

  submit = (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.checkMonthSelect();

    if (Object.keys(this.state.errors).length === 0) {
      this.setState((): * => ({ loading: true }));

      this.props.actions.generateBill(
        this.submitDone,
        this.submitFail,
        this.state.forLast ? undefined : this.state.year,
        this.state.forLast ? undefined : this.state.month
      );
    }
  };

  submitDone = (billings: Array<*>) => {
    let messages = [];
    billings.map(
      (bill: *, i: number): * => {
        messages.push({
          type: bill.message,
          year: bill.year,
          month: bill.month,
          company: bill.company.name
        });
      }
    );

    this.setState({
      errors: {},
      loading: false,
      messages: messages
    });
  };

  submitFail = (errors: ErrorsType): * => {
    this.setState({
      errors: errors,
      loading: false
    });
  };

  render(): React$Element<*> {
    const { errors, loading, messages } = this.state;
    const Months = moment.monthsShort().map(
      (month: string, i: number): * => ({
        value: i + 1,
        label: month
      })
    );

    return (
      <form
        onSubmit={(!loading && this.submit) || undefined}
        className="app-wrapper"
      >
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <SingleCheckBox
                  name="forLast"
                  value={this.state.forLast}
                  onChange={this.handleCheckBoxChange}
                  label={
                    "For Last Month (" +
                    moment
                      .utc()
                      .subtract(1, "month")
                      .format("MMM YYYY") +
                    ")"
                  }
                />
              </Grid>
              {this.state.forLast === false && (
                <Fragment>
                  <Grid item xs={12}>
                    <StyledTextField
                      isRequired={true}
                      label="Set Year"
                      name="year"
                      value={this.state.year}
                      onChange={this.handleTextChange}
                      inpuType="number"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <StyledSelect
                      isRequired={true}
                      label="Set Month"
                      name="month"
                      value={this.state.month}
                      onChange={this.handleTextChange}
                      menus={Months}
                      isInvalid={errors.system !== undefined}
                      isStyled
                    />
                  </Grid>
                </Fragment>
              )}
              <Grid item xs={12}>
                <ErrosDisplay errors={errors} form="close project" />
              </Grid>
              {messages.length > 0 ? (
                <Grid item xs={12}>
                  <div className="banner info">
                    <div className="box" style={{ flexDirection: "column" }}>
                      {messages.map(
                        (message: *, i: number): * => {
                          let date =
                            moment(message.month, "M").format("MMM") +
                            " " +
                            message.year;
                          if (message.type === "DUPLICATE") {
                            return (
                              <span key={i}>
                                <CloseIcon
                                  className="warning-icon right-margin-5"
                                  style={{ verticalAlign: "bottom" }}
                                />
                                <span className="content">
                                  The bill for {message.company} of {date} has
                                  already generated before.
                                </span>
                              </span>
                            );
                          } else if (message.type === "SUCCESS") {
                            return (
                              <span key={i}>
                                <DoneIcon
                                  className="green-icon right-margin-5"
                                  style={{ verticalAlign: "bottom" }}
                                />
                                <span className="content">
                                  The bill for {message.company} of {date}
                                  generated successfully.
                                </span>
                              </span>
                            );
                          }
                        }
                      )}
                    </div>
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <div className="form-right-btn-block">
                    <CancelButton onClick={this.props.onClose} />
                    <SubmitButton
                      loading={loading}
                      disabled={Object.keys(errors).length > 0}
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ generateBill }, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(GenerateBillForm);
